import { Instance } from 'mobx-state-tree';
import { ErrorParamsDtoModelBase } from './ErrorParamsDtoModel.base';

/* The TypeScript type of an instance of ErrorParamsDtoModel */
export interface ErrorParamsDtoModelType extends Instance<typeof ErrorParamsDtoModel.Type> {}

/* A graphql query fragment builders for ErrorParamsDtoModel */
export { selectFromErrorParamsDto, errorParamsDtoModelPrimitives, ErrorParamsDtoModelSelector } from './ErrorParamsDtoModel.base';

/**
 * ErrorParamsDtoModel
 */
export const ErrorParamsDtoModel = ErrorParamsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
